import { naturalStringSort } from './stringHelper';

export const sortClasses = (
  a: { grade?: number | string | null; name: string },
  b: { grade?: number | string | null; name: string },
): number => {
  const aGrade = !!a.grade || a.grade === 0 ? a.grade.toString() : 'F';
  const bGrade = !!b.grade || b.grade === 0 ? b.grade.toString() : 'F';

  // Funktionsklassen an das Ende und nach 'name' sortieren
  if (aGrade === 'F' && bGrade !== 'F') return 1;
  if (aGrade !== 'F' && bGrade === 'F') return -1;
  if (aGrade === 'F' && bGrade === 'F') return naturalStringSort(a.name, b.name);

  // Normale Klassen an den Anfang und zuerst nach 'grade', dann nach 'name' sortieren
  const gradeCompare = naturalStringSort(aGrade, bGrade);
  if (gradeCompare !== 0) return gradeCompare;
  return naturalStringSort(a.name, b.name);
};
